import responseInterceptor from './responseInterceptor'
import { httpClient, apiClient } from '@/core/api/httpClient'

responseInterceptor(httpClient)
responseInterceptor(apiClient)
